export default __webpack_public_path__ + "e22a3f900f2d43c4af9a56d970dbc1c7.png";